import { getStorage, connectStorageEmulator } from 'firebase/storage';

/**
 * Create a Firebase Cloud Storage instance with emulator wiring in dev.
 *
 * @param {import('firebase/app').FirebaseApp} firebase
 * @returns {import('firebase/storage').FirebaseStorage}
 */
export function createStorage(firebase) {
    const storage = getStorage(firebase);

    if (import.meta.env.DEV) {
        const host = import.meta.env.VITE_EMULATOR_HOST || 'localhost';
        const port = Number(import.meta.env.VITE_EMULATOR_PORT_STORAGE) || 9199;
        connectStorageEmulator(storage, host, port);
        // Storage SDK hardcodes _protocol = 'http' in connectStorageEmulator,
        // so patch it to https when the page is served over HTTPS.
        if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
            storage._protocol = 'https';
        }
    }

    return storage;
}
